import React from "react";
import { FaShoppingCart, FaTrash } from "react-icons/fa";

type Props = {
  itemCount: number;
  onViewCart: () => void;
  onClearCart: () => void;
};

const CartOverlay: React.FC<Props> = ({ itemCount, onViewCart, onClearCart }) => {
  if (itemCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-2 sm:p-4">
      <div className="max-w-sm mx-auto">
        <div className="flex gap-2">
          <button
            onClick={onViewCart}
            className="flex-1 bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-lg p-3 sm:p-4 flex items-center justify-between transition-colors duration-200"
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <FaShoppingCart size={16} className="sm:w-5 sm:h-5" />
              <span className="text-sm sm:text-base font-semibold">
                View Cart
              </span>
            </div>
            <span className="bg-white text-orange-500 px-2 py-1 rounded-full text-xs sm:text-sm font-bold">
              {itemCount} {itemCount === 1 ? 'item' : 'items'}
            </span>
          </button>
          <button
            onClick={onClearCart}
            className="bg-red-500 hover:bg-red-600 text-white rounded-lg shadow-lg p-3 sm:p-4 flex items-center justify-center transition-colors duration-200"
            title="Clear Cart"
          >
            <FaTrash size={16} className="sm:w-5 sm:h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartOverlay;